<template>
  <v-btn
    v-tooltip="'Limpar Leituras'"
    icon="fa-regular fa-trash-can"
    color="error"
    :loading="loader.loading"
    @click="clear"
  />
  <v-dialog />
</template>

<script lang="ts" setup>
import ReadingService from '@/services/ReadingService'
import { useDialog } from '@/stores/dialog'
import { useLoader } from '@/stores/loader'
import { useSnackBar } from '@/stores/snackbar'
import Event from '@/types/Event'

const snackbar = useSnackBar()
const dialog = useDialog()
const loader = useLoader()

const { event } = defineProps<{ event: Event }>()
const emits = defineEmits<(e: 'clear') => void>()

const service = new ReadingService()

const clear = async () => {
  try {
    const confirm = await dialog.open({
      title: 'Confirmação de exclusão',
      message: `Realmente deseja limpar as leituras do evento ${event.title}? Essa ação é irreversível.`,
    })

    if (!confirm) {
      snackbar.show('Ação cancelada', 'info')
      return
    }

    loader.increment()

    await service.clear(event.id)
    snackbar.show('Leituras limpas com sucesso!', 'success')
    emits('clear')
  } catch (error) {
    console.error('Error clearing readings:', error)
  } finally {
    loader.decrement()
  }
}
</script>
